import { ECL, Config } from "@dh-libs/ecl-lookup";
import { useAuth } from "providers/CustomAuthProvider";
import configJson from "clientAppSettings.json";
import configJsonDev from "clientAppSettings.Development.json";
import useShowSnackbar from "hooks/useShowSnackbar";

function ECLContent() {
  const { accessToken,isPremium } = useAuth();
const snackbar = useShowSnackbar();
  const config: Config = {
    socketUrl: configJson.PricingMatrix.SocketUrl,
    devUrl: configJson.API_URL,
    clientId: configJson.PricingMatrix.SocketClientId,
    xApiKey: configJson.PricingMatrix.SocketApiKey,
    accessToken: accessToken,
    isPremium: isPremium
  };

  return (
    <div className="lookup-page-shell">
      <ECL
        config={config}
        exportTo={{
          endpoint: "/Queue/Enqueue",
          callbackFunction: () => snackbar("Export Started"),
        }}
      />
    </div>
  );
}

export default ECLContent;
